// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"navigationitem_NavigationItem__vLyvO","active":"navigationitem_active__2J0CS"};